import { render, staticRenderFns } from "./marks.vue?vue&type=template&id=2236abde&scoped=true&"
import script from "./marks.vue?vue&type=script&lang=js&"
export * from "./marks.vue?vue&type=script&lang=js&"
import style0 from "./marks.vue?vue&type=style&index=0&id=2236abde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236abde",
  null
  
)

export default component.exports